import https from 'https';
import {loadIntlPolyfill} from '../../utils/Polyfill';

const fetchTranslations = (language, resolve, reject) => {
	const timeout = setTimeout(() => {
		window.cchome.util.logger.error('Client', 'Translation fetch timed out');
		clearTimeout(timeout);
	}, 5000);

	const path = `/${window.chash}/translations/${language}.json`;

	const obj = {
		hostname: window.location.hostname,
		path,
		method: 'GET',
		port: window.location.port,
		headers: {
			Accept: 'application/json',
		},
		dataType: 'json',
		withCredentials: false,
	};

	const request = https.request(obj, (res) => {
		clearTimeout(timeout);
		if (res.statusCode && res.statusCode >= 400) {
			window.cchome.util.logger.error('Client', 'Problem with Translation request', res);
			reject(new Error('Translation error'));
		}
		else {
			let data = '';
			// set the encoding to UTF8 to prevent decoding issues on certain browsers.
			// https://jira.corp.adobe.com/browse/CCH-4430
			res.setEncoding('utf8');
			res.on('data', chunk => (data += chunk));
			res.on('end', () => {
				// Success!
				try {
					resolve(JSON.parse(data));
				}
				catch (e: any) {
					window.cchome.util.logger.error(
						'Client',
						'Problem with parsing Translation response',
						e.toString(),
					);
					reject(new Error('Translation parse error'));
				}
			});
		}
	});

	request.on('error', (err) => {
		clearTimeout(timeout);
		// There was a connection error of some sort
		window.cchome.util.logger.error('Client', 'Problem with Translation request', err);
		resolve(new Error('Translation error'));
	});

	request.end();
};

class LocalizationService {
	loadTranslations(language) {
		return new Promise((resolve, reject) => {
			if (!window.Intl) {
				loadIntlPolyfill().then(() => fetchTranslations(language, resolve, reject));
			}
			else {
				fetchTranslations(language, resolve, reject);
			}
		});
	}
}

export default new LocalizationService();
